// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type HomeownersTabQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type HomeownersTabQuery = { __typename?: 'Query', project: { __typename?: 'StandaloneProject', id: string, collaborators: Array<{ __typename?: 'ProjectCollaborator', id: string, inviteSent?: Types.Scalars['DateTime']['input'] | null | undefined, role: Types.ProjectCollaboratorRole, collaborator: { __typename?: 'Client', id: string, email: string, firstName: string, lastName: string, lastActive?: Types.Scalars['DateTime']['input'] | null | undefined, phone?: string | null | undefined } }> } | { __typename?: 'Region', id: string, collaborators: Array<{ __typename?: 'ProjectCollaborator', id: string, inviteSent?: Types.Scalars['DateTime']['input'] | null | undefined, role: Types.ProjectCollaboratorRole, collaborator: { __typename?: 'Client', id: string, email: string, firstName: string, lastName: string, lastActive?: Types.Scalars['DateTime']['input'] | null | undefined, phone?: string | null | undefined } }> } | { __typename?: 'Market', id: string, collaborators: Array<{ __typename?: 'ProjectCollaborator', id: string, inviteSent?: Types.Scalars['DateTime']['input'] | null | undefined, role: Types.ProjectCollaboratorRole, collaborator: { __typename?: 'Client', id: string, email: string, firstName: string, lastName: string, lastActive?: Types.Scalars['DateTime']['input'] | null | undefined, phone?: string | null | undefined } }> } | { __typename?: 'Community', id: string, collaborators: Array<{ __typename?: 'ProjectCollaborator', id: string, inviteSent?: Types.Scalars['DateTime']['input'] | null | undefined, role: Types.ProjectCollaboratorRole, collaborator: { __typename?: 'Client', id: string, email: string, firstName: string, lastName: string, lastActive?: Types.Scalars['DateTime']['input'] | null | undefined, phone?: string | null | undefined } }> } | { __typename?: 'Subdivision', id: string, collaborators: Array<{ __typename?: 'ProjectCollaborator', id: string, inviteSent?: Types.Scalars['DateTime']['input'] | null | undefined, role: Types.ProjectCollaboratorRole, collaborator: { __typename?: 'Client', id: string, email: string, firstName: string, lastName: string, lastActive?: Types.Scalars['DateTime']['input'] | null | undefined, phone?: string | null | undefined } }> } | { __typename?: 'Lot', id: string, collaborators: Array<{ __typename?: 'ProjectCollaborator', id: string, inviteSent?: Types.Scalars['DateTime']['input'] | null | undefined, role: Types.ProjectCollaboratorRole, collaborator: { __typename?: 'Client', id: string, email: string, firstName: string, lastName: string, lastActive?: Types.Scalars['DateTime']['input'] | null | undefined, phone?: string | null | undefined } }> } | { __typename?: 'Structure', id: string, collaborators: Array<{ __typename?: 'ProjectCollaborator', id: string, inviteSent?: Types.Scalars['DateTime']['input'] | null | undefined, role: Types.ProjectCollaboratorRole, collaborator: { __typename?: 'Client', id: string, email: string, firstName: string, lastName: string, lastActive?: Types.Scalars['DateTime']['input'] | null | undefined, phone?: string | null | undefined } }> } | { __typename?: 'Unit', id: string, collaborators: Array<{ __typename?: 'ProjectCollaborator', id: string, inviteSent?: Types.Scalars['DateTime']['input'] | null | undefined, role: Types.ProjectCollaboratorRole, collaborator: { __typename?: 'Client', id: string, email: string, firstName: string, lastName: string, lastActive?: Types.Scalars['DateTime']['input'] | null | undefined, phone?: string | null | undefined } }> } };

export type HomeownersTabHomeownerFragment = { __typename?: 'ProjectCollaborator', id: string, inviteSent?: Types.Scalars['DateTime']['input'] | null | undefined, role: Types.ProjectCollaboratorRole, collaborator: { __typename?: 'Client', id: string, email: string, firstName: string, lastName: string, lastActive?: Types.Scalars['DateTime']['input'] | null | undefined, phone?: string | null | undefined } };

export type SendInviteEmailMutationVariables = Types.Exact<{
  input: Types.SendInviteEmailInput;
}>;


export type SendInviteEmailMutation = { __typename?: 'Mutation', sendInviteEmail: { __typename?: 'SendInviteEmailResult', projectCollaborator: { __typename?: 'ProjectCollaborator', id: string, inviteSent?: Types.Scalars['DateTime']['input'] | null | undefined, role: Types.ProjectCollaboratorRole, collaborator: { __typename?: 'Client', id: string, email: string, firstName: string, lastName: string, lastActive?: Types.Scalars['DateTime']['input'] | null | undefined, phone?: string | null | undefined } } } };

export type DeleteProjectCollaboratorMutationVariables = Types.Exact<{
  input: Types.DeleteProjectCollaboratorInput;
}>;


export type DeleteProjectCollaboratorMutation = { __typename?: 'Mutation', deleteProjectCollaborator: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export const HomeownersTabHomeownerFragmentDoc = gql`
    fragment HomeownersTabHomeowner on ProjectCollaborator {
  id
  collaborator {
    id
    email
    firstName
    lastName
    lastActive
    phone
  }
  inviteSent
  role
}
    `;
export const HomeownersTabDocument = gql`
    query HomeownersTab($projectId: ID!) {
  project(id: $projectId) {
    id
    collaborators {
      ...HomeownersTabHomeowner
    }
  }
}
    ${HomeownersTabHomeownerFragmentDoc}`;

/**
 * __useHomeownersTabQuery__
 *
 * To run a query within a React component, call `useHomeownersTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeownersTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeownersTabQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useHomeownersTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HomeownersTabQuery, HomeownersTabQueryVariables> & ({ variables: HomeownersTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomeownersTabQuery, HomeownersTabQueryVariables>(HomeownersTabDocument, options);
      }
export function useHomeownersTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomeownersTabQuery, HomeownersTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomeownersTabQuery, HomeownersTabQueryVariables>(HomeownersTabDocument, options);
        }
export function useHomeownersTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomeownersTabQuery, HomeownersTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HomeownersTabQuery, HomeownersTabQueryVariables>(HomeownersTabDocument, options);
        }
export type HomeownersTabQueryHookResult = ReturnType<typeof useHomeownersTabQuery>;
export type HomeownersTabLazyQueryHookResult = ReturnType<typeof useHomeownersTabLazyQuery>;
export type HomeownersTabSuspenseQueryHookResult = ReturnType<typeof useHomeownersTabSuspenseQuery>;
export type HomeownersTabQueryResult = Apollo.QueryResult<HomeownersTabQuery, HomeownersTabQueryVariables>;
export const SendInviteEmailDocument = gql`
    mutation SendInviteEmail($input: SendInviteEmailInput!) {
  sendInviteEmail(input: $input) {
    projectCollaborator {
      ...HomeownersTabHomeowner
    }
  }
}
    ${HomeownersTabHomeownerFragmentDoc}`;
export type SendInviteEmailMutationFn = Apollo.MutationFunction<SendInviteEmailMutation, SendInviteEmailMutationVariables>;

/**
 * __useSendInviteEmailMutation__
 *
 * To run a mutation, you first call `useSendInviteEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteEmailMutation, { data, loading, error }] = useSendInviteEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInviteEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendInviteEmailMutation, SendInviteEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendInviteEmailMutation, SendInviteEmailMutationVariables>(SendInviteEmailDocument, options);
      }
export type SendInviteEmailMutationHookResult = ReturnType<typeof useSendInviteEmailMutation>;
export type SendInviteEmailMutationResult = Apollo.MutationResult<SendInviteEmailMutation>;
export type SendInviteEmailMutationOptions = Apollo.BaseMutationOptions<SendInviteEmailMutation, SendInviteEmailMutationVariables>;
export const DeleteProjectCollaboratorDocument = gql`
    mutation DeleteProjectCollaborator($input: DeleteProjectCollaboratorInput!) {
  deleteProjectCollaborator(input: $input) {
    emptyResult
  }
}
    `;
export type DeleteProjectCollaboratorMutationFn = Apollo.MutationFunction<DeleteProjectCollaboratorMutation, DeleteProjectCollaboratorMutationVariables>;

/**
 * __useDeleteProjectCollaboratorMutation__
 *
 * To run a mutation, you first call `useDeleteProjectCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectCollaboratorMutation, { data, loading, error }] = useDeleteProjectCollaboratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProjectCollaboratorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProjectCollaboratorMutation, DeleteProjectCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProjectCollaboratorMutation, DeleteProjectCollaboratorMutationVariables>(DeleteProjectCollaboratorDocument, options);
      }
export type DeleteProjectCollaboratorMutationHookResult = ReturnType<typeof useDeleteProjectCollaboratorMutation>;
export type DeleteProjectCollaboratorMutationResult = Apollo.MutationResult<DeleteProjectCollaboratorMutation>;
export type DeleteProjectCollaboratorMutationOptions = Apollo.BaseMutationOptions<DeleteProjectCollaboratorMutation, DeleteProjectCollaboratorMutationVariables>;